/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import Renderer from './Renderer'
import { scaleCanvas } from './util'
import { Command } from './Command'

export default class CanvasRenderer extends Renderer {

    getContext(canvas) {
        return canvas.getContext('2d')
    }

    setupCanvas(canvas) {
        let ctx = this.getContext(canvas)
        ctx.imageSmoothingEnabled = false

        this.size = scaleCanvas(canvas)
        return this.size
    }

    clear(ctx) {
        ctx.clearRect(0, 0, this.size.w, this.size.h)
    }

    drawShapeInContext(ctx, shape, adjustedFrame) {
        shape.layout()
        let commands = shape.commands

        for (let cmd of commands) {
            switch(cmd.type) {
            case Command.Begin:
                cmdBegin(ctx)
                break
            case Command.Rectangle:
                break
            case Command.Ellipse:
                break
            case Command.PathMoveTo:
                cmdPathMoveTo(ctx, cmd.args)
                break
            case Command.PathLineTo:
                cmdPathLineTo(ctx, cmd.args)
                break
            case Command.PathArcTo:
                break
            case Command.PathCurveTo:
                break
            case Command.PathClose:
                cmdPathClose(ctx)
                break
            case Command.Fill:
                cmdFill(ctx, cmd.args)
                break
            case Command.Stroke:
                cmdStroke(ctx, cmd.args)
                break
            default:
                break;
            }
        }
    }

    drawFromCache(ctx, shape) {
        ctx.putImageData(shape._cache, shape.frame.x, shape.frame.y)
    }

    cacheShape(shape) {
        let tmpCanvas = document.createElement('canvas')
        tmpCanvas.width = shape.frame.w
        tmpCanvas.height = shape.frame.h
        let tmpCtx = tmpCanvas.getContext('2d')

        this.drawShapeInContext(tmpCtx, shape, shape.bounds)
        for (let child of shape.children) {
            this.cacheShape(child)
            tmpCtx.putImageData(child._cache, child.frame.x, child.frame.y)
        }

        shape._cache = tmpCtx.getImageData(shape.bounds.x, shape.bounds.y, shape.bounds.w, shape.bounds.h)
        shape._needsDraw = false
    }

}

function cmdBegin(ctx, args) {
    ctx.beginPath()
}

function cmdPathMoveTo(ctx, args) {
    ctx.moveTo(args[0].x, args[0].y)
}

function cmdPathLineTo(ctx, args) {
    ctx.lineTo(args[0].x, args[0].y)
}

function cmdPathClose(ctx) {
    ctx.closePath()
}

function cmdFill(ctx, args) {
    ctx.fillStyle = args[0]
    ctx.fill()
}

function cmdStroke(ctx, args) {
    ctx.strokeStyle = args[0]
    ctx.lineWidth = args[1]
    ctx.stroke()
}
